import { render, staticRenderFns } from "./slideshow.block.pug?vue&type=template&id=73b45e70&scoped=true&lang=pug&external"
import script from "./slideshow.block.ts?vue&type=script&lang=ts&external"
export * from "./slideshow.block.ts?vue&type=script&lang=ts&external"
import style0 from "./slideshow.block.sass?vue&type=style&index=0&id=73b45e70&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b45e70",
  null
  
)

export default component.exports